module.exports = __webpack_public_path__ + "paiol--062e6859.png";


//////////////////
// WEBPACK FOOTER
// ./_source/img/parceiros/paiol.png
// module id = 239
// module chunks = 0